var _g, _g2, _g3, _g4, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiltelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 33,
    viewBox: "0 0 103 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_16_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.457965 21.9736C0.26549 21.7826 0.26044 21.4729 0.446582 21.2756L3.51976 18.0191C3.71043 17.817 4.02923 17.8092 4.22964 18.0015L11 24.5L11 32.439L0.457965 21.9736Z",
    fill: "#E6F1E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_16_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 24.4998L20.9419 14.7598C21.1237 14.5818 21.4102 14.5686 21.6075 14.7293L25.1244 17.5931C25.3545 17.7805 25.3717 18.1258 25.1614 18.3352L10.9932 32.4379L11 24.4998Z",
    fill: "#E6F1E9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_16_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72295 11.6389C2.52409 11.4511 2.51437 11.1398 2.69939 10.9383L5.99713 7.34839C6.19534 7.13261 6.53578 7.13274 6.73383 7.34867L11 12C11 12 10.9976 19.5463 11 19.5C11.0021 19.4593 4.35258 13.1777 2.72295 11.6389Z",
    fill: "#E6F1E9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_16_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 12L22.5153 0.359555C22.7111 0.16163 23.0308 0.161759 23.2265 0.359839L26.5143 3.68867C26.7104 3.88724 26.7102 4.20399 26.5087 4.39717C24.1443 6.6649 11.0059 19.2755 10.9998 19.5C10.993 19.7467 10.9998 12 10.9998 12Z",
    fill: "#E6F1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 12L22.5153 0.359555C22.7111 0.16163 23.0308 0.161759 23.2265 0.359839L26.5143 3.68867C26.7104 3.88724 26.7102 4.20399 26.5087 4.39717C24.1443 6.6649 11.0059 19.2755 10.9998 19.5C10.993 19.7467 10.9998 12 10.9998 12Z",
    fill: "#E6F1E9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8798 23.9793C36.6478 23.9793 35.5758 23.7313 34.6638 23.2353C33.7518 22.7233 33.0478 22.0033 32.5518 21.0753C32.0558 20.1473 31.8078 19.0593 31.8078 17.8113C31.8078 16.5633 32.0558 15.4913 32.5518 14.5953C33.0478 13.6833 33.7518 12.9873 34.6638 12.5073C35.5758 12.0113 36.6478 11.7633 37.8798 11.7633C38.6318 11.7633 39.3758 11.8833 40.1118 12.1233C40.8478 12.3633 41.4558 12.6993 41.9358 13.1313L41.0478 15.2193C40.6318 14.8513 40.1598 14.5713 39.6318 14.3793C39.1198 14.1873 38.6238 14.0913 38.1438 14.0913C37.1038 14.0913 36.2958 14.4193 35.7198 15.0753C35.1598 15.7153 34.8798 16.6353 34.8798 17.8353C34.8798 19.0193 35.1598 19.9553 35.7198 20.6433C36.2958 21.3153 37.1038 21.6513 38.1438 21.6513C38.6078 21.6513 39.1038 21.5553 39.6318 21.3633C40.1598 21.1713 40.6318 20.8833 41.0478 20.4993L41.9358 22.6113C41.4558 23.0273 40.8398 23.3633 40.0878 23.6193C39.3518 23.8593 38.6158 23.9793 37.8798 23.9793ZM43.7761 23.7393V6.81926H46.7761V14.3553H46.4401C46.7921 13.5073 47.3361 12.8673 48.0721 12.4353C48.8241 11.9873 49.6721 11.7633 50.6161 11.7633C51.5601 11.7633 52.3361 11.9393 52.9441 12.2913C53.5521 12.6433 54.0081 13.1793 54.3121 13.8993C54.6161 14.6033 54.7681 15.4993 54.7681 16.5873V23.7393H51.7681V16.7313C51.7681 16.1233 51.6881 15.6273 51.5281 15.2433C51.3841 14.8593 51.1521 14.5793 50.8321 14.4033C50.5281 14.2113 50.1361 14.1153 49.6561 14.1153C49.0801 14.1153 48.5761 14.2433 48.1441 14.4993C47.7121 14.7393 47.3761 15.0913 47.1361 15.5553C46.8961 16.0033 46.7761 16.5313 46.7761 17.1393V23.7393H43.7761ZM63.5991 23.9793C62.2711 23.9793 61.1271 23.7313 60.1671 23.2353C59.2071 22.7393 58.4631 22.0353 57.9351 21.1233C57.4231 20.2113 57.1671 19.1313 57.1671 17.8833C57.1671 16.6673 57.4151 15.6033 57.9111 14.6913C58.4231 13.7793 59.1191 13.0673 59.9991 12.5553C60.8951 12.0273 61.9111 11.7633 63.0471 11.7633C64.1671 11.7633 65.1271 12.0033 65.9271 12.4833C66.7271 12.9633 67.3431 13.6433 67.7751 14.5233C68.2231 15.4033 68.4471 16.4513 68.4471 17.6673V18.5553H59.5911V16.8273H66.3351L65.9511 17.1873C65.9511 16.0993 65.7111 15.2673 65.2311 14.6913C64.7511 14.0993 64.0631 13.8033 63.1671 13.8033C62.4951 13.8033 61.9191 13.9633 61.4391 14.2833C60.9751 14.5873 60.6151 15.0273 60.3591 15.6033C60.1191 16.1633 59.9991 16.8353 59.9991 17.6193V17.7873C59.9991 18.6673 60.1351 19.3953 60.4071 19.9713C60.6791 20.5473 61.0871 20.9793 61.6311 21.2673C62.1751 21.5553 62.8471 21.6993 63.6471 21.6993C64.3031 21.6993 64.9591 21.6033 65.6151 21.4113C66.2711 21.2033 66.8711 20.8833 67.4151 20.4513L68.2551 22.4673C67.6951 22.9313 66.9911 23.2993 66.1431 23.5713C65.2951 23.8433 64.4471 23.9793 63.5991 23.9793ZM76.2469 23.9793C75.0149 23.9793 73.9429 23.7313 73.0309 23.2353C72.1189 22.7233 71.4149 22.0033 70.9189 21.0753C70.4229 20.1473 70.1749 19.0593 70.1749 17.8113C70.1749 16.5633 70.4229 15.4913 70.9189 14.5953C71.4149 13.6833 72.1189 12.9873 73.0309 12.5073C73.9429 12.0113 75.0149 11.7633 76.2469 11.7633C76.9989 11.7633 77.7429 11.8833 78.4789 12.1233C79.2149 12.3633 79.8229 12.6993 80.3029 13.1313L79.4149 15.2193C78.9989 14.8513 78.5269 14.5713 77.9989 14.3793C77.4869 14.1873 76.9909 14.0913 76.5109 14.0913C75.4709 14.0913 74.6629 14.4193 74.0869 15.0753C73.5269 15.7153 73.2469 16.6353 73.2469 17.8353C73.2469 19.0193 73.5269 19.9553 74.0869 20.6433C74.6629 21.3153 75.4709 21.6513 76.5109 21.6513C76.9749 21.6513 77.4709 21.5553 77.9989 21.3633C78.5269 21.1713 78.9989 20.8833 79.4149 20.4993L80.3029 22.6113C79.8229 23.0273 79.2069 23.3633 78.4549 23.6193C77.7189 23.8593 76.9829 23.9793 76.2469 23.9793ZM82.1433 23.7393V6.81926H85.1433V16.9953H85.1913L89.9193 12.0033H93.5433L87.6393 18.2433V16.9953L93.8793 23.7393H90.2073L85.1913 18.5073H85.1433V23.7393H82.1433Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9398 14.7393V13.9113L98.8078 10.8273C99.0718 10.5393 99.2838 10.2713 99.4438 10.0233C99.6118 9.76726 99.7358 9.51926 99.8158 9.27926C99.8958 9.03926 99.9358 8.79926 99.9358 8.55926C99.9358 8.09526 99.7918 7.74326 99.5038 7.50326C99.2238 7.25526 98.8118 7.13126 98.2678 7.13126C97.8518 7.13126 97.4558 7.21126 97.0798 7.37126C96.7118 7.52326 96.3638 7.75926 96.0358 8.07926L95.6278 7.22726C95.9478 6.90726 96.3518 6.65126 96.8398 6.45926C97.3278 6.26726 97.8398 6.17126 98.3758 6.17126C98.9518 6.17126 99.4358 6.26326 99.8278 6.44726C100.228 6.62326 100.532 6.88326 100.74 7.22726C100.948 7.56326 101.052 7.97526 101.052 8.46326C101.052 8.71926 101.02 8.97126 100.956 9.21926C100.892 9.45926 100.796 9.70326 100.668 9.95126C100.548 10.1913 100.392 10.4393 100.2 10.6953C100.016 10.9513 99.7958 11.2153 99.5398 11.4873L97.0558 14.1153V13.7913H101.388V14.7393H95.9398Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16_987",
    x: 0.310303,
    y: 17.8622,
    width: 10.6897,
    height: 14.6768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_987"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_16_987",
    x: 10.9932,
    y: 14.6171,
    width: 14.3154,
    height: 17.9208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_987"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_16_987",
    x: 2.56689,
    y: 7.18665,
    width: 8.43311,
    height: 12.4135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_987"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_16_987",
    x: 10.9968,
    y: 0.211182,
    width: 15.6638,
    height: 19.3946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_987"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiltelogo);
export default __webpack_public_path__ + "static/media/whiltelogo.df3e6d377e05bf5545b5c68e0959c222.svg";
export { ForwardRef as ReactComponent };